import { request } from '@/shared/api/request'

export const getChecks = (sectionCode, page = 0, size = 10) => {
	return request({ url: `selftest/auth/page?&page=${page}&size=${size}`, method: 'POST', data: sectionCode })
}
